module.exports = __webpack_public_path__ + "img/icon_appstore.f9cff4cc.svg";